







































































































import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import RequestButton from '@/components/RequestButton'

import InventorySelectorStep from './InventorySelectorStep'
import DateStep from './DateStep'
import LocationStep from './LocationStep'
import PointsOfInterestStep from './PointsOfInterestStep'
import EventStep from './EventStep'
import AudienceStep from './AudienceStep'
import BrandInfoStep from './BrandInfoStep'
import CreativeStep from './CreativeStep'
import ProfileStep from './ProfileStep'

import SubmitWizardTriggerModal from '@triggers/CampaignWizard/SubmitWizardTriggerModal'

settings =
  name: 'CampaignCreateWizard'

  resources:
    form_campaign:
      resourceName: 'form_campaign'
      slug: 'brand_reps/:brandRepId/form_campaign/edit'

  vue:
    store: ['member']
    mixins: [WizardService.wizard()]

    components: {
      RequestButton,
      InventorySelectorStep,
      DateStep,
      LocationStep,
      PointsOfInterestStep,
      EventStep,
      AudienceStep,
      BrandInfoStep,
      CreativeStep,
      ProfileStep,
      SubmitWizardTriggerModal
    }

    data: ->
      searchTime: null
      slim: true

    computed:
      progressBarStyle: -> { width: (((@activeStep.idx + 1) / @steps.length) * 100)  + '%' }

      isFirstStep: -> @activeStep.idx is 0
      isLastStep: ->
        return true if @org?.id and @nextStep?.name is 'profile'
        @activeStep.idx + 1 is @steps.length
      nextStep: -> @steps[@activeStep.idx + 1]

      campaignData: -> @prime?.form_campaign?.data || {}
      brandRepId: -> @$route.query.brandRepId or @member?.brand_rep?.id
      org: -> @campaignData.org
      creatives: -> @campaignData.creatives
      listingClasses: ->
        data = @marketplace?.listing?.classes
        order = @marketplace.listing?.promoted?.classes
        @listingClassOptions = @hashToElementUIOptions data, order
      listingTypes: ->
        data = @marketplace?.listing?.types
        order = @marketplace.listing?.promoted?.types
        @listingTypeOptions = @hashToElementUIOptions data, order
      listingCategories: ->
        data = @marketplace?.listing?.categories
        order = @marketplace.listing?.promoted?.categories
        @listingCategoryOptions = @hashToElementUIOptions data, order
      listingAudiences: ->
        data = @marketplace?.listing?.audiences
        order = @marketplace.listing?.promoted?.audiences
        @listingAudienceOptions = @hashToElementUIOptions data, order

      onSiteSpaceOptions: ->
        booth_10x10: '10 x 10'
        booth_10x20: '10 x 20'
        booth_20x40: '20 x 40'
        booth_40x60: '40 x 60'
        # custom: 'Custom'

      creativeHasSampling: -> !!@creatives?.product_sampling?.length
      creativeHasVideoWall: -> !!@creatives?.video_wall?.length
      creativeHasSocialPost: -> !!@creatives?.social_media_post?.length
      creativeHasPromo: -> !!@creatives?.promo?.length
      creativeHasOnSiteSpace: -> !!@creatives?.onsite_space?.length

    methods:
      # inventoryStepValidator: ->
      #   inventoryIsSelected = !!Object.values(@creatives).length
      #   @setStepError "inventory", "No Inventory Is Selected" unless inventoryIsSelected

      hiNext: ->
        @validateActiveStep()
        return unless @stepIsValid()
        @next({ skipSave: true })
        @debounce(@save, 300)

      hiBack: ->
        @back({ skipSave: true })
        @debounce(@save, 300)

      hiClose: ->
        @save()
        @$router.push({ name: 'CampaignListPage' })

      save: ->
        @saveItem('prime.form_campaign', null, skipFlash: true)

      searchOnList: (text, list, searchMethod) ->
        return new Promise((resolve, reject) =>
          clearTimeout(@searchTime)
          @searchTime = setTimeout(() =>
            options = {}

            if searchMethod
              resolve(searchMethod())

            for key, value of list
              if "#{value}".toLowerCase().includes("#{text}".toLowerCase())
                options[key] = value

            resolve(options)
          , 300)
        )

      debounce: (cb, time = 300) ->
        clearTimeout(@searchTime)
        @searchTime = setTimeout(cb, time)

      scrollStepToSection: (selector, offset) ->
        @scrollContainerTo('.step', selector, offset)

      hiSubmitWizardTrigger: ->
        @validateActiveStep()
        return unless @stepIsValid()
        payloadOptions = { form_campaign: @prime.form_campaign.data }
        @$refs.submitWizardTrigger.fire(payloadOptions)
      onFormCampaignSubmit: (data, response) ->
        @$refs.submitWizardTrigger.close()

        if @currentMemberIsSuperUser()
          @$router.push({ name: 'CampaignShowPage', params: { campaignId: response.id } })
        else if @member.wait_listed
          @$router.push({ name: 'WaitListSponsor' })
        else
          @$router.push({ name: 'CampaignShowPage', params: { campaignId: response.id } })

      generateCreativeDescriptor: (type, key, activation_id=null) ->
        activation_snapshot = @generateActivationSnapshot(type, key) unless activation_id?
        { type, activation_id, activation_snapshot }

      generateActivationSnapshot: (type, key) ->
        prototype = {...@campaignData.activation_prototype }
        snapshot = prototype[key]
        snapshot

      addCreativeType: (type, key) ->
        creativeDescriptor = @generateCreativeDescriptor type, key
        @creatives[key] ||= []
        @creatives[key].push creativeDescriptor
        @syncCreatives()

      removeCreativeType: (type, key) ->
        delete @creatives[key]
        @syncCreatives()

      setCreativeType: (type, key) ->
        creativeDescriptor = @generateCreativeDescriptor type, key
        delete @creatives[k] for k of @creatives
        @creatives[key] = [creativeDescriptor]
        @syncCreatives()

      syncCreatives: ->
        @prime.form_campaign.data.creatives = Object.assign({}, @creatives)

    watch:
      steps: ->
        @navToStepName @$route.query.step, { skipSave: true } if @$route.query.step?

export default VueOptions.vue settings
